import { render } from "./vipForm.vue?vue&type=template&id=5e9145fa&scoped=true"
import script from "./vipForm.vue?vue&type=script&lang=js"
export * from "./vipForm.vue?vue&type=script&lang=js"

import "./vipForm.vue?vue&type=style&index=0&id=5e9145fa&scoped=true&lang=css"
import "./vipForm.vue?vue&type=style&index=1&id=5e9145fa&lang=css"

import exportComponent from "C:\\src\\web\\finance\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e9145fa"]])

export default __exports__